/* eslint-disable import/prefer-default-export */
import EventClass from "common/utils/ui/event-class";
import "./digital-assets-pdp-details.scss";

export const licenseToggle = ({ eventCallback }) =>
  new EventClass({
    eventSelector: ".js-asset-modal-license-toggle",
    eventCallback
  });
